import { defineConfig } from "../config";

export const CDNService = {
  getSystemsIcons,
  getSystemsMarkers,
  getPlanningsMarkers,
  getClusterIcon,
};

const { CDNUrl } = defineConfig.CDN_SERVICE;

//TODO: cambia iconUrlResolver nelle pianificazioni

const normalizeSegment = (value, fallback = "") => {
  if (value === null || value === undefined) {
    return fallback;
  }

  const normalized = String(value).trim();
  return normalized.length ? normalized : fallback;
};

function getSystemsIcons(channel = "OOH", type = "cartello") {
  const completePath = normalizeSegment(channel, "OOH") + "/" + normalizeSegment(type, "cartello") + ".svg";
  return CDNUrl + "/alessi/icons/systems/" + completePath
}

function getSystemsMarkers(channel = "OOH", type = "cartello", status = "active") {
  const normalizedType = normalizeSegment(type, "cartello");
  const normalizedStatus = normalizeSegment(status, "active").toLowerCase();
  const normalizedChannel = normalizeSegment(channel, "OOH").toUpperCase();
  let completePath = "";
  if (normalizedType === "tiny-markers") {
    completePath = normalizedType + "/" + normalizedStatus + ".svg";
  } else {
    completePath = normalizedChannel + "/" + normalizedType + "/" + normalizedStatus + ".svg";
  }

  return CDNUrl + "/alessi/icons/markers/systems/" + completePath
}

function getPlanningsMarkers(channel = "OOH", type = "cartello", status = "available") {
  const normalizedType = normalizeSegment(type, "cartello");
  const normalizedStatus = normalizeSegment(status, "available");
  const normalizedChannel = normalizeSegment(channel, "OOH").toUpperCase();
  let completePath = "";
  if (normalizedType === "tiny-markers") {
    completePath = normalizedType + "/" + normalizedStatus + ".svg";
  } else {
    completePath = normalizedChannel + "/" + normalizedType + "/" + normalizedStatus + ".svg";
  }
  return CDNUrl + "/alessi/icons/markers/plannings/" + completePath
}

function getClusterIcon() {
  return CDNUrl + "/alessi/icons/markers/cluster/blue.svg";
}